import * as Engine from "../Engine";
import { SoccerPlaygroundConfig, Sizes } from "./";

export class CornerMarks extends Engine.Component {

    cornerDistanceMarkerUpperLeft: Engine.Line;
    cornerDistanceMarkerUpperRight: Engine.Line;
    cornerDistanceMarkerBottomLeft: Engine.Line;
    cornerDistanceMarkerBottomRight: Engine.Line;

    constructor(public config: SoccerPlaygroundConfig) {
        super();

        const length = 0.5 * config.conversionFactor;

        this.cornerDistanceMarkerUpperLeft = new Engine.Line(
            new Engine.Vector2(config.topLeftCorner.x + Sizes.DistanceRadius * config.conversionFactor, config.topLeftCorner.y), 
            new Engine.Vector2(config.topLeftCorner.x + Sizes.DistanceRadius * config.conversionFactor, config.topLeftCorner.y - length) 
        );

        this.cornerDistanceMarkerUpperRight = new Engine.Line(
            new Engine.Vector2(config.topRightCorner.x - Sizes.DistanceRadius * config.conversionFactor, config.topRightCorner.y), 
            new Engine.Vector2(config.topRightCorner.x - Sizes.DistanceRadius * config.conversionFactor, config.topRightCorner.y - length) 
        );

        this.cornerDistanceMarkerBottomLeft = new Engine.Line(
            new Engine.Vector2(config.bottomLeftCorner.x + Sizes.DistanceRadius * config.conversionFactor, config.bottomLeftCorner.y), 
            new Engine.Vector2(config.bottomLeftCorner.x + Sizes.DistanceRadius * config.conversionFactor, config.bottomLeftCorner.y + length) 
        );

        this.cornerDistanceMarkerBottomRight = new Engine.Line(
            new Engine.Vector2(config.bottomRightCorner.x - Sizes.DistanceRadius * config.conversionFactor, config.bottomRightCorner.y), 
            new Engine.Vector2(config.bottomRightCorner.x - Sizes.DistanceRadius * config.conversionFactor, config.bottomRightCorner.y + length) 
        );

        this.children.push(
            this.cornerDistanceMarkerUpperLeft,
            this.cornerDistanceMarkerUpperRight,
            this.cornerDistanceMarkerBottomLeft,
            this.cornerDistanceMarkerBottomRight
        );
    }

    draw(ctx: CanvasRenderingContext2D): void {
        super.draw(ctx);
        ctx.restore();

        this.drawCornerArcs(ctx);
    }

    private drawCornerArcs(ctx: CanvasRenderingContext2D) {
        const length = Sizes.CornerArcRadius * this.config.conversionFactor;
        // Upper left
        ctx.beginPath();
        ctx.arc(this.config.topLeftCorner.x, this.config.topLeftCorner.y, length, 0, 0.5 * Math.PI);
        ctx.stroke();

        // Upper right
        ctx.beginPath();
        ctx.arc(this.config.topRightCorner.x, this.config.topRightCorner.y, length, 0.5 * Math.PI, 1.0 * Math.PI);
        ctx.stroke();

        // Lower left
        ctx.beginPath();
        ctx.arc(this.config.bottomLeftCorner.x, this.config.bottomLeftCorner.y, length, 1.5 * Math.PI, 0);
        ctx.stroke();

        // Lower Right
        ctx.beginPath();
        ctx.arc(this.config.bottomRightCorner.x, this.config.bottomRightCorner.y, length, Math.PI, 1.5 * Math.PI);
        ctx.stroke();
    }
}